import React from 'react';
import classNames from 'classnames';

import css from './IconHourGlassLine.module.css';

/**
 * Add icon: "+"
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} "add" icon
 */
const IconHourGlassLine = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9993 16L12.0558 19.9052C8.1591 23.764 6.21077 25.6934 6.75622 27.358C6.80311 27.5011 6.86133 27.6403 6.93035 27.7743C7.7333 29.3333 10.4886 29.3333 15.9993 29.3333C21.5101 29.3333 24.2654 29.3333 25.0683 27.7743C25.1374 27.6403 25.1956 27.5011 25.2425 27.358C25.7879 25.6934 23.8396 23.764 19.9429 19.9052L15.9993 16ZM15.9993 16L19.9429 12.0948C23.8396 8.236 25.7879 6.30663 25.2425 4.64199C25.1956 4.4989 25.1374 4.3597 25.0683 4.22569C24.2654 2.66667 21.5101 2.66667 15.9993 2.66667C10.4886 2.66667 7.7333 2.66667 6.93035 4.22569C6.86133 4.3597 6.80311 4.4989 6.75622 4.64199C6.21077 6.30663 8.1591 8.23601 12.0558 12.0948L15.9993 16Z"
        stroke="#113A69"
        stroke-width="1.5"
      />
      <path
        d="M13.334 7.33333H18.6673"
        stroke="#113A69"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M13.334 24.6667H18.6673"
        stroke="#113A69"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default IconHourGlassLine;
